import { CustomCurrencyEnum } from '../Enum/CustomCurrencyEnum';

class Price {
    value: number | string;

    constructor(value: number | string) {
        this.value = (value as number).toFixed(2);
    }

    public static factory(value: number | string): Price {
        let numericValue = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;

        if (numericValue === null || numericValue === undefined || isNaN(numericValue)) {
            return new Price(0);
        }

        return new Price(numericValue);
    }

    public convertByRate(rate: number): Price {
        let value = (parseFloat(this.value as string) * rate).toFixed(2);

        return Price.factory(parseFloat(value));
    }

    public toCurrencyString(currencyCode: string): string {
        const formattedValue = (this.value as string).replace(/\B(?=(\d{3})+(?!\d))/g, " ");

        if (currencyCode === CustomCurrencyEnum.UAH) {
           return `${formattedValue} грн.`
        }

        return `${formattedValue} ${currencyCode}`
    }
}

export default Price;